import { useMemo, useState } from 'react'

export function useBoolean(initialState = false) {
  const [value, setValue] = useState(initialState)

  const callbacks = useMemo(
    () => ({
      setTrue: () => setValue(true),
      setFalse: () => setValue(false),
      toggle: () => setValue(prev => !prev)
    }),
    []
  )

  return [value, callbacks] as const
}
